export const TENANT_OPTIONS_STORAGE_KEY = "tenantOptions";

export const TENANT_OPTIONS_DEFAULT = {
    tenantId: undefined,
    tenantName: undefined,
    isGPEnabled: undefined,
  }